new Vue({
    el:'#joinUs',
    data(){
        return{
            selectedCountry: '',
            selectedCity: '',
            // 自定义 dropdown 状态
            countryOpen: false,
            cityOpen: false,
            cityData: {
                'United Kingdom': [
                    'London',
                    'Cambridge',
                    'Wales',
                    'Birmingham'
                ],

                'Indonesia': [
                    'Bekasi',
                    'Jakarta'
                ],

                'Iraq': [
                    'Baghdad'
                ],

                'Italy': [
                    'Rome'
                ],

                'Ukraine': [
                    'Kyiv and Eastern Ukraine'
                ],

                'South Africa': [
                    'Cape Town'
                ],

                'United States': [
                    'Chicago',
                    'Kentucky (Louisville, Lexington preferred)',
                    'North Carolina(Any city)',
                    'Illinois(Any city)',
                    'Oregon(Any city)',
                    'Washington(Any city)',
                    'Pennsylvania(Any city)',
                    'Florida(Any city)'
                ],

                'Czech Republic': [
                    'Prague'
                ],

                'Canada': [
                    'Calgary',
                    'Vancouver',
                    'Montreal'
                ],

                'South Korea': [
                    'Seoul',
                    'Gyeonggi Province'
                ],

                'France': [
                    'Toulouse',
                    'Nante'
                ],

                'Russia': [
                    'Novosibirsk'
                ],

                'Egypt': [
                    'Cairo'
                ],

                'Saudi Arabia': [
                    'Riyadh',
                    'Dammam',
                    'Hofuf'
                ]
            },
            
            loadFlag:false,
            popup:false,
            formPopup:false,
            user:{
                name:'',
                email:'',
                phone:'',
                location:'',
                isHave:'',
                type:'OXVA'
            },
            data:[],
            submitFlag:true,
        }
    },
    computed: {
        // Country 下拉列表
        countryList: function () {
            return Object.keys(this.cityData);
        },
        // 根据 Country 自动获取 City
        cityList: function () {
            if (!this.selectedCountry) {
                return [];
            }
            return this.cityData[this.selectedCountry] || [];
        }
    },
    methods:{
        async submitForm(){
            if(!this.submitFlag){
                return showMessage('Sending, please wait...','success')
            }
            if(this.user.name==''||this.user.email==''||this.user.phone==''||this.user.location==''|| this.user.isHave==''){
                return showMessage('Please complete all required fields.','error')
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                return showMessage('Email format error','error')
            }

            showMessage('Sending, please wait...','success')
            this.submitFlag = false
            
            if(this.data.name && this.data.size){
                //上传文件
                const formData = new FormData();
                formData.append("files", this.data);
                let res=await axios.post('https://service.oxvatech.cn/email/upload',formData,{headers: {
                    'Content-Type': 'multipart/form-data'
                }});
                if(res.status==200){
                    let files = res.data.files;

                    var params=new URLSearchParams();
                    params.append('info',JSON.stringify(this.user));
                    params.append('files',JSON.stringify(files));
                    let result=await axios.post('https://service.oxvatech.cn/email/joinUs',params);
                    if(result.status == 200){
                        showMessage('Sent successfully','success')
                        this.popup = this.formPopup = false
                    }else{
                        showMessage('Error! please contact us','error')
                    }
                }else{
                    showMessage('Error! please contact us','error')
                }
            }else{
                var params=new URLSearchParams();
                params.append('info',JSON.stringify(this.user));
                params.append('files','');
                let result=await axios.post('https://service.oxvatech.cn/email/joinUs',params);
                if(result.status == 200){
                    showMessage('Sent successfully','success')
                    this.popup = this.formPopup = false
                }else{
                    showMessage('Error! please contact us','error')
                }
            }
            this.submitFlag=true
        },
        upload(event){
            var file = event.target.files[0]
            if(file.size>10*1024*1024){
                showMessage('The uploaded file cannot exceed 10M','error')
                return;
            }else{
                this.data = file
            }
        },
        deleteData(){
            this.data = []
        },
        /* Country */
        toggleCountry: function () {
            this.countryOpen = !this.countryOpen;
            // Country 展开时关闭 City
            this.cityOpen = false;
        },
        selectCountry: function (country) {
            // 如果国家发生变化，清空城市
            if (this.selectedCountry !== country) {
                this.selectedCountry = country;
                this.selectedCity = '';
            }
            this.countryOpen = false;
            this.cityOpen = false;
        },
        /* City */
        toggleCity: function () {
            // 没选 Country，不允许打开 City
            if (!this.selectedCountry) {
                return;
            }
            this.cityOpen = !this.cityOpen;
            // City 展开时关闭 Country
            this.countryOpen = false;
        },
        selectCity: function (city) {
            this.selectedCity = city;
            this.cityOpen = false;
        },
        closeDropdowns: function () {
            this.countryOpen = false;
            this.cityOpen = false;
        }
    },
    created(){
        this.loadFlag = true
    },
    mounted(){
        document.addEventListener( 'click', this.closeDropdowns );

        function showUp(dom){
            gsap.from(dom, {
                y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
                scrollTrigger: {
                    trigger: dom,
                    start: 'top bottom-=20%',
                    end: '+=0',
                    //toggleActions: 'play none none reverse',
                }
            })
        }
        
        var wFlag = window.innerWidth>750

        $('.box1_btn div:nth-child(1)').click(function(){
            var element = document.querySelector(".box4");
            element.scrollIntoView({block: "start",behavior: "smooth"});
        })
        $('.box1_btn div:nth-child(2)').click(function(){
            var element = document.querySelector(".box3_items2");
            element.scrollIntoView({block: "start",behavior: "smooth"});
        })

        if(wFlag){
            ScrollTrigger.create({
                trigger: '.box2',
                start:'top top+=2%',
                end: '+=80%',
                scrub:1,
                pin:true,
                animation: gsap.timeline()
                    .to({}, { duration:0.2 })
                    .from('.box2_item div img', { filter: 'brightness(1)' })
                    .from('.box2_item div p', { opacity:0 },'<')
                    .to({}, { duration:0.2 })
                    .to('.box2_item', { opacity:0.4 })
                    .to('.box2_round div', { opacity:0 },'<')
                    .to('.box2_round img', { opacity:1 },'<')
            })
        }else{
            showUp('.box2_title')
        }
    
        showUp('.box3_items1 .box3_title')
        showUp('.box3_items2 .box3_title')
        showUp('.box3_items3 .box3_title')
        
        ScrollTrigger.create({
            trigger: '.box3_items3',
            start:'top bottom-=30%',
            end: '+=0%',
            toggleActions: 'play none none reverse',
            animation: gsap.timeline()
                .to('.box3_item3 div .svg_line', { strokeDashoffset:0,stagger:0.3 })
        })

        if(wFlag){
            const $svg = $('.route_svg');
            const $route = $('#redRoute');
            const $routePaths = $('.route-path');
            const $cursor = $('#routeCursor');
            const $icons = $('.route_icon');
    
            if (!$svg.length || !$route.length || !$cursor.length || !$icons.length ) return;
    
            // SVG path 的 getTotalLength / getPointAtLength 是原生 SVG API，
            // 所以这里只取 jQuery 对象里的原生 DOM 节点调用。
            const route = $route[0];
            
            ScrollTrigger.create({
                trigger: '.box2',
                start: 'bottom top+=10%',
                end: '+=170%',
                pin: true
            });
    
            const routeLength = route.getTotalLength();
            const routeState = { progress: 0 };
            const CURSOR_RADIUS = Number($cursor.attr('r')) || 44;
    
            const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
            const offset = progress => routeLength * (1 - progress);
    
            // 红线 + 白色外边框初始隐藏
            gsap.set($routePaths.toArray(), {
                strokeDasharray: `${routeLength} ${routeLength}`,
                strokeDashoffset: routeLength
            });
    
            // 三个图标根据路径进度自动定位
            $icons.each(function () {
                const $icon = $(this);
                const iconProgress = Number($icon.attr('data-progress'));
                const point = route.getPointAtLength(routeLength * iconProgress);
                const width = Number($icon.attr('width')) || 40;
                const height = Number($icon.attr('height')) || 40;
    
                $icon.attr({
                    x: point.x - width / 2,
                    y: point.y - height / 2
                });
    
                gsap.set(this, {
                    opacity: 0.3
                });
            });
    
            const setIconActive = ($icon, active) => {
                const state = active ? '1' : '0';
    
                if ($icon.attr('data-route-active') === state) return;
    
                $icon.attr('data-route-active', state);
    
                // 白圈覆盖图标时，用 SVG 原生滤镜变成纯黑
                if (active) {
                    $icon.attr('filter', 'url(#routeIconBlack)');
                } else {
                    $icon.removeAttr('filter');
                }
    
                gsap.to($icon[0], {
                    opacity: active ? 1 : 0.3,
                    duration: 0.12,
                    overwrite: true
                });
            };
    
            const renderRoute = () => {
                const progress = routeState.progress;
                const point = route.getPointAtLength(routeLength * progress);
    
                // 红线绘制
                gsap.set($routePaths.toArray(), {
                    strokeDashoffset: offset(progress)
                });
    
                // 白圈跟随红线头部
                $cursor.attr({
                    cx: point.x,
                    cy: point.y
                });
    
                // 前段无阴影，后段逐渐出现
                const shadowProgress = clamp((progress - 0.58) / 0.20, 0, 1);
                const shadowAlpha = 0.20 * shadowProgress;
    
                $cursor.css(
                    'filter',
                    `drop-shadow(0 0 8px rgba(0, 0, 0, ${shadowAlpha}))`
                );
    
                // 判断白圈是否覆盖图标
                $icons.each(function () {
                    const $icon = $(this);
                    const iconProgress = Number($icon.attr('data-progress'));
                    const iconPoint = route.getPointAtLength(
                        routeLength * iconProgress
                    );
    
                    const distance = Math.hypot(
                        point.x - iconPoint.x,
                        point.y - iconPoint.y
                    );
    
                    const iconSize = Math.max(
                        Number($icon.attr('width')) || 40,
                        Number($icon.attr('height')) || 40
                    );
    
                    const hitDistance =
                        CURSOR_RADIUS + iconSize * 0.35;
    
                    setIconActive($icon, distance <= hitDistance);
                });
            };
    
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $('.box2')[0],
                    start: 'top top-=10%',
                    end: '+=200%',
                    scrub: 0.8,
                    anticipatePin: 1,
                    onRefresh: renderRoute
                }
            });
    
            // 第 1 个图标
            tl.to(routeState, {
                progress: 0.82,
                duration: 1,
                ease: 'none',
                onUpdate: renderRoute
            });
    
            tl.to({}, {
                duration: 1.5
            });
    
            // 第 2 个图标
            tl.to(routeState, {
                progress: 0.91,
                duration: 1,
                ease: 'none',
                onUpdate: renderRoute
            });
    
            tl.to({}, {
                duration: 0.8
            });
    
            // 第 3 个图标
            tl.to(routeState, {
                progress: 1,
                duration: 1,
                ease: 'none',
                onUpdate: renderRoute
            });
    
            renderRoute();
        }else{
            const $mobileNav = $('.box3_mobile_nav');
            const $navItems = $mobileNav.find('.box3_mobile_nav_item');
            const $sections = $('.box3_items1, .box3_items2, .box3_items3');
    
            if (!$mobileNav.length || !$navItems.length || !$sections.length) return;
    
            let activeIndex = -1;
    
            const setMobileNav = index => {
                index = Math.max(0, Math.min(index, $navItems.length - 1));
    
                if (activeIndex === index) return;
                activeIndex = index;
    
                // 第1项：红色到第一个图标；第2项：到中间；第3项：整条变红
                const progress = ['22%', '56%', '100%'][index];
    
                $mobileNav
                    .attr('data-active', index + 1)
                    .css('--mobile-nav-progress', progress);
    
                $navItems.each(function (i) {
                    const $item = $(this);
    
                    $item
                        .toggleClass('is-past', i < index)
                        .toggleClass('is-active', i === index)
                        .toggleClass('is-future', i > index)
                        .attr('aria-current', i === index ? 'true' : null);
                });
            };
    
            const updateMobileNav = () => {
                const scrollTop = $(window).scrollTop();
    
                // sticky top + 导航自身高度，作为切换判定线。
                // 当下一板块标题进入导航下方时，导航切换到下一项。
                const stickyTop = parseFloat($mobileNav.css('top')) || 0;
                const triggerLine =
                    scrollTop +
                    stickyTop +
                    $mobileNav.outerHeight() +
                    30;
    
                let index = 0;
    
                $sections.each(function (i) {
                    if ($(this).offset().top <= triggerLine) {
                        index = i;
                    }
                });
    
                setMobileNav(index);
            };
    
            // 点击导航项，滚动到对应板块
            $navItems.on('click', function () {
                const $item = $(this);
                const $target = $($item.attr('data-target'));
    
                if (!$target.length) return;
    
                const stickyTop = parseFloat($mobileNav.css('top')) || 0;
                const offset =
                    stickyTop +
                    $mobileNav.outerHeight() +
                    8;
    
                $('html, body').stop().animate({
                    scrollTop: $target.offset().top - offset
                }, 450);
            });
    
            $(window).on(
                'scroll.joinUsMobileNav resize.joinUsMobileNav',
                updateMobileNav
            );
    
            setMobileNav(0);
            updateMobileNav();
        }
            
        ScrollTrigger.create({
            trigger: '.box4',
            start:'top top+=5%',
            end: '+=20%',
            pin:true,
            toggleActions: 'play none none reverse',
            animation: gsap.timeline()
                .to('.box4_img', { filter: 'brightness(0.4)' })
                .from('.box4_title,.box4_text', { opacity:0 })
        })
    
        showUp('.box5_title')
        if(wFlag){
            var $content = $(".box5_move");
            var html = $content.html();
    
            // 复制一份，实现无缝滚动
            $content.append(html);
    
            var width = $content.children().eq(0).outerWidth(true);
    
            var left = 0;
    
            function move() {
                left--;
    
                if (-left >= width) {
                    left = 0;
                }
    
                $content.css("transform", "translateX(" + left + "px)");
            }
    
            setInterval(move,20); // 数值越小速度越快
            
            ScrollTrigger.create({
                trigger: '.box5',
                start:'top top+=5%',
                end: '+=20%',
                pin:true,
                toggleActions: 'play none none reverse',
                animation: gsap.timeline()
                    .from('.box6', { clipPath: 'inset(50% 0% 50% 0%)' })
            })
        }else{
            new Swiper('.box5Swiper', {
                autoplay: true,
                effect: 'cards',
            })
    
            showUp('.box6_info')
        }
    },
    beforeDestroy: function () {
        document.removeEventListener( 'click', this.closeDropdowns );
    }
})
